import React from "react";
import { ExternalLink, Github } from "lucide-react";
import securityApi from "../api/securityApi";

/**
 * The one Connect-GitHub button. Two flavours:
 *  - "oauth": redirects into the GitHub OAuth flow (grants repo listing).
 *  - "app":   links out to the GitHub App installation page (grants scanning).
 *
 * They are not interchangeable. The compliance flow requires an App
 * installation; OAuth alone never satisfies it.
 */
const ConnectGitHubButton = ({
  variant = "oauth",
  installationUrl = null,
  label,
  fullWidth = true,
  // Adds ?force_login=true, which makes GitHub re-prompt for credentials.
  // Only correct when the point is to re-authorize; a first-run "Connect"
  // must not drag an already-connected user through a fresh login.
  forceLogin = false,
  className = "",
}) => {
  const classes = [
    fullWidth ? "w-full sm:w-auto" : "",
    "inline-flex items-center justify-center gap-2 px-6 py-3 min-h-[44px] rounded-lg",
    "bg-teal-600 hover:bg-teal-700 text-white font-medium transition-colors",
    "disabled:opacity-50 disabled:cursor-not-allowed",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (variant === "app") {
    const text = label || "Install GitHub App";
    if (!installationUrl) {
      return (
        <button
          type="button"
          disabled
          title="GitHub App is not configured. Contact your administrator."
          className={classes}
        >
          <ExternalLink className="h-5 w-5" />
          <span>{text}</span>
        </button>
      );
    }
    return (
      <a
        href={installationUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={classes}
      >
        <ExternalLink className="h-5 w-5" />
        <span>{text}</span>
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={() => securityApi.initiateGithubAuth(forceLogin)}
      className={classes}
    >
      <Github className="h-5 w-5" />
      <span>{label || "Connect GitHub"}</span>
    </button>
  );
};

export default ConnectGitHubButton;
